import { useParams } from "react-router-dom";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import StagesTable from "../../Pages/Report/StagesTable";

const StagesTableContainers=()=>{
  const { reportId } = useParams();

    return(
    <>
    <SharedDiv
        showTitle={true}
        titleName="مراحل التقرير"
        child={[
          <>
            <StagesTable reportId={reportId}/>
          </>,
        ]}
      />
    </>
    )
}
export default StagesTableContainers;